import { useDashboardEventStream } from "../../hooks/useDashboardEventStream.js";

/**
 * Subscribes to dashboard SSE `lifecycle` events (via {@link DashboardSseProvider}).
 */
export function LifecycleEventToast() {
  const { lifecycleHint } = useDashboardEventStream();
  if (!lifecycleHint) return null;
  return (
    <div
      role="status"
      className="fixed bottom-4 right-4 z-[100] max-w-md rounded-lg border border-brand-500/30 bg-surface-900/95 px-4 py-3 text-sm text-surface-100 shadow-lg dark:border-brand-400/25"
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-brand-300">Lifecycle</p>
      <p className="mt-1 text-surface-50">{lifecycleHint}</p>
    </div>
  );
}
